<template>
  <div class="order-input">
    <div class="input-group input-group-left">
      <input type="text" :value="props.label" disabled :class="{ 'invalid-input': invalid }" />
      <select
        name="time"
        ref="timeField"
        v-model="time"
        :disabled="disabled"
        :class="{ 'invalid-input': invalid }"
      >
        <option v-for="(time, index) in availableTimes" :key="index" :value="time.value">
          {{ time.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, toRefs } from 'vue'

const props = defineProps({
  time: {
    type: String,
    required: true,
    default: '',
  },
  label: {
    type: String,
    required: true,
    default: '',
  },
  availableTimes: {
    type: Array,
    required: true,
  },
  invalid: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: Boolean,
})

const { time: propTime, availableTimes, invalid } = toRefs(props)
const emit = defineEmits(['update:time'])

const time = computed({
  get: () => propTime.value,
  set: val => {
    emit('update:time', val)
  },
})

// const rules = {
//   time: {
//     required,
// 		() => time
//   },
// }

// const $v = useVuelidate(rules, { time })

const timeField = ref()

defineExpose({ time, timeField })
</script>
